import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[var(--sh-ink)] text-white" data-testid="footer">
      <div className="section-container py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Brand */}
          <div className="lg:col-span-4">
            <div className="mb-6">
              <div className="font-serif font-semibold tracking-[0.12em] uppercase text-white" style={{ fontSize: '1.0625rem' }}>Sandend House</div>
              <div className="font-sans uppercase text-white/40" style={{ fontSize: '0.5625rem', letterSpacing: '0.14em', marginTop: '2px' }}>The Knox Family Office</div>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs">
              Built through enterprise. Held for generations.
            </p>
          </div>

          {/* Navigation */}
          <div className="lg:col-span-2">
            <h4 className="font-sans text-xs font-semibold tracking-[0.12em] uppercase text-white/40 mb-5">Navigate</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/the-house" className="text-white/60 hover:text-white transition-colors text-sm" data-testid="footer-house-link">The House</Link>
              <Link to="/founder" className="text-white/60 hover:text-white transition-colors text-sm" data-testid="footer-founder-link">Founder</Link>
              <Link to="/portfolio" className="text-white/60 hover:text-white transition-colors text-sm" data-testid="footer-portfolio-link">Portfolio</Link>
              <Link to="/intellectual-property" className="text-white/60 hover:text-white transition-colors text-sm" data-testid="footer-ip-link">Intellectual Property</Link>
              <Link to="/stewardship" className="text-white/60 hover:text-white transition-colors text-sm" data-testid="footer-stewardship-link">Stewardship</Link>
              <Link to="/insights" className="text-white/60 hover:text-white transition-colors text-sm" data-testid="footer-insights-link">Insights</Link>
              <Link to="/contact" className="text-white/60 hover:text-white transition-colors text-sm" data-testid="footer-contact-link">Contact</Link>
            </nav>
          </div>

          {/* Portfolio */}
          <div className="lg:col-span-3">
            <h4 className="font-sans text-xs font-semibold tracking-[0.12em] uppercase text-white/40 mb-5">Portfolio</h4>
            <nav className="flex flex-col gap-3">
              <a href="https://therlkgroup.com" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors text-sm inline-flex items-center gap-1" data-testid="footer-rlk-link">
                The RLK Group <ArrowUpRight size={12} />
              </a>
              <a href="https://letwise.io" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors text-sm inline-flex items-center gap-1" data-testid="footer-letwise-link">
                Letwise <ArrowUpRight size={12} />
              </a>
              <a href="https://thegrazingtrust.com" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors text-sm inline-flex items-center gap-1" data-testid="footer-grazing-link">
                The Grazing Trust <ArrowUpRight size={12} />
              </a>
            </nav>
          </div>

          {/* Contact */}
          <div className="lg:col-span-3">
            <h4 className="font-sans text-xs font-semibold tracking-[0.12em] uppercase text-white/40 mb-5">Contact</h4>
            <a href="mailto:contact@theknox.co.uk" className="text-white/60 hover:text-white transition-colors text-sm" data-testid="footer-email">
              contact@theknox.co.uk
            </a>
          </div>
        </div>

        {/* Family quotation */}
        <div className="mt-16 pt-8 border-t border-white/10 text-center">
          <p className="font-serif italic text-white/40 text-lg" data-testid="footer-quote">
            &ldquo;Go Forth and Multiply&rdquo;
          </p>
          <p className="text-white/25 text-xs mt-2">
            Robert Knox, 1936&ndash;2020
          </p>
        </div>

        {/* Legal */}
        <div className="mt-10 pt-8 border-t border-white/10">
          <p className="text-white/30 text-xs leading-relaxed mb-4" data-testid="footer-legal">
            Sandend House is a trading name of KFO Limited. KFO Limited is a private limited company registered in Scotland under company number SC882510. Registered office: Unit 4, 416 Hamilton Road, Cambuslang, Glasgow, Scotland, G72 7XR.
          </p>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <p className="text-white/30 text-xs" data-testid="footer-copyright">
              &copy; {currentYear} KFO Limited. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-white/30 hover:text-white/60 transition-colors text-xs" data-testid="footer-privacy-link">Privacy Policy</Link>
              <Link to="/terms" className="text-white/30 hover:text-white/60 transition-colors text-xs" data-testid="footer-terms-link">Terms of Use</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
